import { render, staticRenderFns } from "./Leadlike.vue?vue&type=template&id=682a0a93&scoped=true&"
import script from "./Leadlike.vue?vue&type=script&lang=js&"
export * from "./Leadlike.vue?vue&type=script&lang=js&"
import style0 from "./Leadlike.vue?vue&type=style&index=0&id=682a0a93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682a0a93",
  null
  
)

export default component.exports